module.exports = __webpack_public_path__ + "static/media/HK.facfdaf7.png";